export default __webpack_public_path__ + "static/media/IMG_0004_11_11zon.300ea55e.jpg";